import React from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { useTranslation } from 'react-i18next';
import Cookies from 'universal-cookie';
import './style.css';
export default function LanguageDropdown() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { t, i18n } = useTranslation();
  const cookies = new Cookies();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    document.documentElement.lang = lang;
    cookies.set('language', lang);
    handleClose();
  };

  return (
    <>
      <div onClick={handleClick} className="lang-dropdown-flag-container">
        {i18n.language === 'fr' ? (
          <>
            <div className="lang-dropdown-flag-name">FR&nbsp;</div>
            {/* <img src="/assets/images/france.png" alt="FR" className="lang-dropdown-flag" /> */}
          </>
        ) : i18n.language === 'ar' ? (
          <>
            <div className="lang-dropdown-flag-name">AR&nbsp;</div>
            {/* <img src="/assets/images/algeria.png" alt="AR" className="lang-dropdown-flag" />{' '} */}
          </>
        ) : (
          <>
            <div className="lang-dropdown-flag-name">EN&nbsp;</div>
            {/* <img src="/assets/images/english.png" alt="EN" className="lang-dropdown-flag" />{' '} */}
          </>
        )}
      </div>
      <Menu id="simple-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem
          onClick={() => {
            changeLanguage('fr');
          }}
        >
          <div className="lang-dropdown-flag-name">FR&nbsp;</div>
          <div>
            {/* <img src="/assets/images/france.png" alt="FR" className="lang-dropdown-flag" /> */}
          </div>
        </MenuItem>
        <MenuItem
          onClick={() => {
            changeLanguage('ar');
          }}
        >
          <div className="lang-dropdown-flag-name">AR&nbsp;</div>
          <div>
            {/* <img src="/assets/images/algeria.png" alt="DZ" className="lang-dropdown-flag" /> */}
          </div>
        </MenuItem>
        <MenuItem
          onClick={() => {
            changeLanguage('en');
          }}
        >
          <div className="lang-dropdown-flag-name">EN&nbsp;</div>
          <div>
            {/* <img src="/assets/images/english.png" alt="EN" className="lang-dropdown-flag" /> */}
          </div>
        </MenuItem>
      </Menu>
    </>
  );
}
